import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

export default {
  camelCase,
  snakeCase,
  debounce,
  cloneDeep,
  get,
};
